import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import {Link} from "react-router-dom";
import Illustration from "../../assets/img/illustration_questionnaire.svg";
import {SiteMapRoutes} from "../../stores/site.map";
import SanitizeHTML from "../../sanitize-html/sanitize.html";

type Props = {appStore?: AppStore};
const QuestionnaireHeader: React.FC<Props> = useAppStore()((props: Props) => {
	const userStore = props.appStore.userStore;
	const memberHeaderHTMLText =
		"<p>This is your opportunity to take some time to reflect honestly on your professional journey and think about your development needs. Your answers and results won’t be seen by anyone else, however we would recommend having a discussion with your line manager, HR professional, coach or mentor about your career progression and any skills gaps identified once you get your results.</p><p>There are 56 statements in total for you to answer – it should take you about 15-20 minutes to complete (including some time for self-reflection). Don’t worry if you need to come out before completing all the statements – the system will save your progress.</p><p>When considering your answers, you might start thinking about situations and scenarios where this would apply. You should choose the answer that would apply in most cases, or the one you lean towards the most. This will help you get a more accurate profile based on your needs.</p>";
	const nonMemberHeaderTextParagraphFirst =
		"The CIH professional standards build on seven characteristics developed, tested, and refined to enable you to think about your professional development needs and how you can contribute to the professionalism of your organisation and the wider industry. They're relevant for everyone who works in housing, whatever your role or specialism.";
	const alreadyAMemberText =
		"CIH members access a more comprehensive version that provides an in-depth, personalised report offering tailored content and targeted professional development activities.";
	const seeHowYouCompareTextFirst =
		"Take some time to reflect honestly on your professional journey and think about your development needs. There are 21 statements below for you to complete (it can take around ten minutes). When considering your answers, start thinking about situations and scenarios where this would apply and choose the answer that would apply in most cases or the one you lean towards the most. This will help you get a more accurate profile based on your needs.";
	const seeHowYouCompareTextSecond = "Once you've completed the questionnaire, you'll see how you compare to the professional standards. Your answers and results won't be seen by anyone else.";

	return (
		<div className="cih-flex cih-2cols cih-my-4">
			{!userStore.isLoggedIn && (
				<div>
					<h2 className="cih-h2 cih-mb-2">Understanding my professional behaviours</h2>
					<p className="para-narrow">{nonMemberHeaderTextParagraphFirst}</p>
					<div className="vspace10"></div>
				</div>
			)}
			<div className="cih-col">
				{userStore.isLoggedIn && (
					<div>
						<h2 className="cih-h2 cih-mb-3">Understanding my professional behaviours</h2>
						<p className="para-narrow">{nonMemberHeaderTextParagraphFirst}</p>
					</div>
				)}
				{!userStore.isMember && (
					<div className="cih-mt-1 cih-txt-lead">
						{!userStore.isLoggedIn && (
							<div>
								<h3 className="cih-h3">Already a member?</h3>
								<p>{alreadyAMemberText}</p>
								<Link className="cih-txt-lead cih-txt-link cih-mb-1" to={SiteMapRoutes.Login}>
									If you are already a member, please log in here.
								</Link>
							</div>
						)}
						<h3 className="cih-h2 cih-mb-2">See how you compare</h3>
						<p>{seeHowYouCompareTextFirst}</p>
						<p>{seeHowYouCompareTextSecond}</p>
					</div>
				)}
				{userStore.isMember && (
					<div className="cih-mt-1 cih-txt-lead">
						<SanitizeHTML html={memberHeaderHTMLText} />
					</div>
				)}
			</div>

			<div className="cih-spc"></div>
			<div className="cih-col cih-flex cih-justify-center">
				<img src={Illustration} alt="" />
			</div>
		</div>
	);
});

export default QuestionnaireHeader;
